import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import SearchResultsObjIcon from "../../assets/images/search_results_obj.svg";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("SearchResults", {
  title: "Search Results",
  thumbnail: SearchResultsObjIcon,
  hideInSelectionDialogs: true,
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "navigationBackgroundImage",
    ],
    "SearchResults"
  ),
  properties: [
    "title",
    "navigationBackgroundImage",
    "hideInNavigation",
    ...defaultPageProperties,
  ],
  propertiesGroups: [socialCardsPropertiesGroup, metadataPropertiesGroup],
  initialContent: {
    ...metadataInitialContent,
    ...defaultPageInitialContent,
    title: "Search Results",
  },
});
